(function () {
  'use strict';

  if (window.__NXEDC_MINICART_READY__) return;
  window.__NXEDC_MINICART_READY__ = true;

  var SECTION_ID = 'nxedc-cart-drawer';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function cartRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root;
    }
    return '/';
  }

  function getMinicart() {
    return document.querySelector('[data-nxedc-minicart]');
  }

  function getContentRoot() {
    return document.getElementById('shopify-section-nxedc-cart-drawer');
  }

  function updateHeaderCount(count) {
    document.querySelectorAll('.nxedc-header__cart, .nxedc-mobile-nav__cart').forEach(function (cartBtn) {
      var badge = cartBtn.querySelector('.nxedc-header__count, .nxedc-mobile-nav__badge');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = cartBtn.classList.contains('nxedc-mobile-nav__cart')
            ? 'nxedc-mobile-nav__badge'
            : 'nxedc-header__count';
          cartBtn.appendChild(badge);
        }
        badge.textContent = String(count);
      } else if (badge) {
        badge.remove();
      }
    });
  }

  function openMinicart() {
    var minicart = getMinicart();
    if (!minicart) return;
    minicart.classList.add('is-open');
    minicart.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('open-minicart');
    document.body.classList.add('open-minicart');
    var closeBtn = minicart.querySelector('.nxedc-minicart__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeMinicart() {
    var minicart = getMinicart();
    if (!minicart) return;
    minicart.classList.remove('is-open');
    minicart.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('open-minicart');
    document.body.classList.remove('open-minicart');
  }

  function setLoading(loading) {
    var minicart = getMinicart();
    if (minicart) minicart.classList.toggle('is-loading', loading);
  }

  function bindMinicartEvents(root) {
    if (!root) return;

    root.querySelectorAll('[data-nxedc-minicart-close]').forEach(function (btn) {
      btn.addEventListener('click', closeMinicart);
    });

    root.querySelectorAll('[data-nxedc-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-nxedc-cart-remove');
        if (key) changeLine(key, 0);
      });
    });

    root.querySelectorAll('[data-nxedc-cart-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-nxedc-minicart-qty]');
        var input = wrap && wrap.querySelector('[data-nxedc-cart-qty-input]');
        if (!input) return;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
        input.value = String(next);
        queueQtyUpdate(input);
      });
    });

    root.querySelectorAll('[data-nxedc-cart-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-nxedc-minicart-qty]');
        var input = wrap && wrap.querySelector('[data-nxedc-cart-qty-input]');
        if (!input) return;
        var next = (parseInt(input.value, 10) || 0) + 1;
        input.value = String(next);
        queueQtyUpdate(input);
      });
    });

    root.querySelectorAll('[data-nxedc-cart-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        queueQtyUpdate(input);
      });
    });

    root.querySelectorAll('[data-nxedc-minicart-checkout]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        handleMobileCheckout(event, btn);
      });
    });

    var checkoutForm = root.querySelector('[data-nxedc-minicart-checkout-form]');
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', function (event) {
        var btn = checkoutForm.querySelector('[data-nxedc-minicart-checkout]');
        if (btn) handleMobileCheckout(event, btn);
      });
    }
  }

  var qtyTimer = null;
  var pendingQtyInput = null;

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function navigateCheckout() {
    var checkoutUrl = cartRoot() + 'checkout';
    setLoading(false);
    if (window.location.href.indexOf(checkoutUrl) !== -1) return;
    window.location.assign(checkoutUrl);
  }

  function flushPendingQtyUpdate() {
    if (!pendingQtyInput) return Promise.resolve();
    var input = pendingQtyInput;
    pendingQtyInput = null;
    clearTimeout(qtyTimer);
    qtyTimer = null;
    var key = input.getAttribute('data-line-key');
    var qty = parseInt(input.value, 10);
    if (!key || isNaN(qty)) return Promise.resolve();
    return changeLine(key, qty, { skipRefresh: true });
  }

  function handleMobileCheckout(event, btn) {
    if (!isMobileViewport()) return;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
    if (btn.disabled) return;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    flushPendingQtyUpdate()
      .catch(function () {})
      .then(navigateCheckout);
  }

  function queueQtyUpdate(input) {
    pendingQtyInput = input;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () {
      qtyTimer = null;
      pendingQtyInput = null;
      var key = input.getAttribute('data-line-key');
      var qty = parseInt(input.value, 10);
      if (!key || isNaN(qty)) return;
      changeLine(key, qty);
    }, 350);
  }

  function changeLine(key, quantity, options) {
    options = options || {};
    if (!options.skipRefresh) setLoading(true);
    return fetch(cartRoot() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart update failed');
        return res.json();
      })
      .then(function (cart) {
        updateHeaderCount(cart.item_count);
        if (options.skipRefresh) return cart;
        return refreshMinicart();
      })
      .catch(function () {
        if (!options.skipRefresh) setLoading(false);
      });
  }

  function refreshMinicart() {
    var root = getContentRoot();
    if (!root) return Promise.resolve();

    setLoading(true);
    var sectionUrl = cartRoot() + '?sections=' + SECTION_ID;

    return fetch(sectionUrl, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Section fetch failed');
        return res.json();
      })
      .then(function (data) {
        var html = data[SECTION_ID];
        if (!html) throw new Error('Missing section HTML');
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var next = temp.querySelector('#shopify-section-' + SECTION_ID) || temp.firstElementChild;
        if (next && root.parentNode) {
          next.setAttribute('data-nxedc-minicart-content', '');
          root.replaceWith(next);
          bindMinicartEvents(next);
        }
        return fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) {
        if (res && res.ok) return res.json();
      })
      .then(function (cart) {
        if (cart) updateHeaderCount(cart.item_count);
      })
      .catch(function () {
        /* Section API unavailable — keep existing markup */
      })
      .finally(function () {
        setLoading(false);
      });
  }

  function buyNowFromForm(form, btn) {
    if (!form || (btn && btn.disabled)) return Promise.resolve();

    var formData = new FormData(form);
    if (btn) btn.disabled = true;
    setLoading(true);

    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        window.location.href = cartRoot() + 'checkout';
      })
      .catch(function (err) {
        var msg = (err && err.description) || (err && err.message) || 'Could not start checkout';
        alert(msg);
      })
      .finally(function () {
        if (btn) btn.disabled = false;
        setLoading(false);
      });
  }

  function addToCartFromForm(form) {
    var formData = new FormData(form);
    var addBtn = form.querySelector('[name="add"]');
    if (addBtn) addBtn.disabled = true;
    setLoading(true);

    return fetch(cartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function () {
        return refreshMinicart().then(function () {
          openMinicart();
        });
      })
      .catch(function (err) {
        var msg = (err && err.description) || (err && err.message) || 'Could not add to cart';
        alert(msg);
      })
      .finally(function () {
        if (addBtn) addBtn.disabled = false;
        setLoading(false);
      });
  }

  function shouldAjaxCartForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.hasAttribute('data-nxedc-ajax-cart')) return true;
    if (form.id === 'nxedc-product-form') return true;
    if (!form.closest('.nxedc-clone')) return false;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') !== -1) return true;
    return Boolean(form.querySelector('[name="add"]'));
  }

  function handleCartFormSubmit(e) {
    var form = e.target;
    if (!shouldAjaxCartForm(form)) return;
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }
    addToCartFromForm(form);
  }

  function initMinicartShell() {
    var minicart = getMinicart();
    if (!minicart) return;

    bindMinicartEvents(minicart);

    minicart.querySelectorAll('[data-nxedc-minicart-close]').forEach(function (el) {
      el.addEventListener('click', closeMinicart);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && minicart.classList.contains('is-open')) {
        closeMinicart();
      }
    });
  }

  function initCartTriggers() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-nxedc-minicart-open], .nxedc-header__cart, .nxedc-mobile-nav__cart');
      if (!trigger) return;
      e.preventDefault();
      refreshMinicart().then(openMinicart);
    });
  }

  function initProductForms() {
    document.addEventListener('submit', handleCartFormSubmit, true);

    document.addEventListener('click', function (e) {
      var buyNowBtn = e.target.closest('[data-nxedc-buy-now]');
      if (!buyNowBtn) return;
      var form = buyNowBtn.closest('form');
      if (!form || !shouldAjaxCartForm(form)) return;
      e.preventDefault();
      e.stopPropagation();
      buyNowFromForm(form, buyNowBtn);
    });

    document.querySelectorAll('[data-nxedc-ajax-cart], #nxedc-product-form').forEach(function (form) {
      form.setAttribute('data-nxedc-ajax-cart', '');
    });
  }

  ready(function () {
    initMinicartShell();
    initCartTriggers();
    initProductForms();
    initStandardActionsBridge();
  });

  function initStandardActionsBridge() {
    var actions = window.Shopify && window.Shopify.actions;
    if (!actions || !actions.openCart || actions.openCart.__nxedcBound) return;
    actions.openCart.__nxedcBound = true;

    actions.openCart.configure({
      handler: function () {
        return refreshMinicart().then(openMinicart);
      }
    });
  }

  window.NXEDCMinicart = {
    open: openMinicart,
    close: closeMinicart,
    refresh: refreshMinicart
  };
})();
